<mat-icon matTooltip="Check status" (click)="checkJobStatus($event)">info</mat-icon>
